import React from "react";
import { Iframe } from "../iframe/iframe.layout";
import { EventFormHeader } from "./eventForm.header";
import { PostMessage } from "../iframe/iframe.state";
import { EventTemplate } from "../models/Events/Events";
import { EventPage } from "../cmsPage/cmsPageState";
import { NotFoundLayout } from "../notFound/notFoundLayout";

type EventFormProps = {
  eventId: string
  eventData: EventTemplate
  pageData: EventPage
  embedCode: string
  width?: number | string
  height?: number
  handlePostMessage?: (m: PostMessage) => void
};

export const EventFormLayout = (props: EventFormProps): JSX.Element => {
  let { eventData, pageData, eventId, embedCode, handlePostMessage } = props
  const title = `iframe-${eventId}`
  const url = `${window.EventRegisterHost}/inschrijven/?id=${eventData.id}&event=${eventId}`

  const currentEvent = eventData.events.find((e) => e.id == eventId)
  if (!currentEvent) return NotFoundLayout()

  return <div className="region">
    <EventFormHeader event={currentEvent} pageData={pageData} />
    <Iframe
      messageOrigin={window.EventRegisterHost}
      handlePostMessage={handlePostMessage}
      title={title}
      url={url}
      embedCode={embedCode == '' ? null! : embedCode}
      onLoaded={() => {null}}
      loading="eager"
    />
  </div>;
}
